import React, { FunctionComponent } from 'react';

import {
  PublishingSource,
  TimelineEntry,
} from '../../../../../types/__generated__';
import { FitbitAvatarBadge } from '../../FitbitTimelineEntry/FitbitAvatarBadge';
import { StravaAvatarBadge } from '../../StravaTimelineEntry/StravaAvatarBadge';

import timelineEntryStyles from '../TimelineEntry.scss';

interface BadgeProps {
  publishingSource: TimelineEntry['publishingSource'];
}

export const Badge: FunctionComponent<BadgeProps> = ({ publishingSource }) => {
  switch (publishingSource) {
    case PublishingSource.Strava:
      return (
        <span className={timelineEntryStyles.avatarBadge}>
          <StravaAvatarBadge />
        </span>
      );
    case PublishingSource.Fitbit:
      return (
        <span className={timelineEntryStyles.avatarBadge}>
          <FitbitAvatarBadge />
        </span>
      );
    default:
      return null;
  }
};
